// extracted by mini-css-extract-plugin
export default {"Container":"VerifyCode_Container__FCeoe"};